import "./Classes.css";
import React from "react";
import { images } from "../../Assets/assetsHelper";
import { MoonLoader } from "react-spinners";
import CourseCard from "../../Components/Molecules/Cards/CourseCard/CourseCard";
import TextFieldInput from "../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { Pagination } from "@mui/material";
import Filter from "../../Components/Molecules/Filter/Filter";
import SortButton from "../../Components/Molecules/SortButton/SortButton";
import ClassIcon from "@mui/icons-material/Class";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

function Classes({
  role,
  page,
  searchData,
  search,
  setSearchData,
  setSearch,
  classes,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  setFilter,
  totalCount,
  setRowsPerPage,
  handleChangeRowsPerPage,
  setSort,
  currentSort,
}) {
  // if (loading) {
  //   return (
  //     <div className="mainContainer">
  //       <div className="loadingContainer">
  //         <MoonLoader color="#012369" size={40} />
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="mainContainer">
      {/* Page Header */}
      <div className="pageHeader">
        <div className="pageTitle">
          <div className="titleIcon">
            <ClassIcon />
          </div>
          <div className="titleContent">
            <h1>Classes Management</h1>
            <p>Manage and view all educational classes</p>
          </div>
        </div>

        {(role === "admin" || role === "school") && (
          <button
            className="actionButton primary addButton"
            onClick={() => navigate("/classes/add")}
          >
            <AddIcon />
            Add Class
          </button>
        )}
      </div>

      {loading ? (
        ""
      ) : (
        <>
          {/* Statistics Cards */}
          <div className="statsGrid">
            <div className="statCard">
              <div className="statIcon primary">
                <ClassIcon />
              </div>
              <div className="statContent">
                <h4>Total Classes</h4>
                <h2>{totalCount || 0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon success">
                <CheckCircleIcon />
              </div>
              <div className="statContent">
                <h4>Active Classes</h4>
                <h2>{totalCount || 0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon warning">
                <CancelIcon />
              </div>
              <div className="statContent">
                <h4>Terminated Classes</h4>
                <h2>
                  0
                  {/* {classes?.filter((cls) => cls.isTerminated).length || 0} */}
                </h2>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Classes Cards */}
      <div className="contentSection">
        <div className="tableHeader">
          <h2 className="sectionTitle">Classes List</h2>
        </div>

        <div className="searchFilterHeader">
          <div className="searchFilterGroup">
            <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search classes..."}
              className="modernSearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search !== searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13) {
                  if (search !== searchData) {
                    setSearch(searchData);
                  }
                }
              }}
            />
            <Filter schools teachers courses terminated setFilter={setFilter} />
            <SortButton
              setSort={setSort}
              currentSort={currentSort}
              startDate
              createdAt
            />
          </div>
        </div>

        {loading ? (
          ""
        ) : (
          <>
            <div className="tableHeaderCount">
              <div className="tableActions">
                <span className="resultsCount">
                  Showing {classes?.length || 0} classes
                </span>
              </div>
            </div>
          </>
        )}

        {loading ? (
          <div className="loadingContainer">
            <MoonLoader color="#012369" size={40} />
          </div>
        ) : (
          <>
            {classes && classes.length > 0 ? (
              <div className="classesGrid">
                {classes.map((item) => (
                  <div
                    key={item.id}
                    className="classCard"
                    onClick={() => navigate(`/classes/${item.id}`)}
                  >
                    <div className="classHeader">
                      <div className="classIcon">
                        <ClassIcon />
                      </div>
                      <h3 className="classTitle">{item?.className}</h3>
                      <div
                        className={`statusIndicator ${
                          item?.isTerminated ? "inactive" : "active"
                        }`}
                      >
                        {item?.isTerminated ? (
                          <CancelIcon />
                        ) : (
                          <CheckCircleIcon />
                        )}
                        {/* {item?.isTerminated ? "Terminated" : "Active"} */}
                      </div>
                    </div>

                    <div className="classContent">
                      <div className="classDetails">
                        <div className="detailItem">
                          <MenuBookIcon className="detailIcon" />
                          <span className="detailLabel">Program:</span>
                          <span className="detailValue">
                            {item?.course?.title || "N/A"}
                          </span>
                        </div>

                        <div className="detailItem">
                          <PersonIcon className="detailIcon" />
                          <span className="detailLabel">Instructor:</span>
                          <span className="detailValue">
                            {item?.teacher?.name || "N/A"}
                          </span>
                        </div>

                        <div className="detailItem">
                          <SchoolIcon className="detailIcon" />
                          <span className="detailLabel">School:</span>
                          <span className="detailValue">
                            {item?.school?.name || "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <div className="emptyIcon">
                  <ClassIcon />
                </div>
                <h3>No Classes Found</h3>
                <p>
                  No classes have been created yet. Start by adding your first
                  class.
                </p>
                {(role === "admin" || role === "school") && (
                  <button
                    className="actionButton primary"
                    onClick={() => navigate("/classes/add")}
                    style={{ margin: "20px auto" }}
                  >
                    <AddIcon />
                    Add First Class
                  </button>
                )}
              </div>
            )}
          </>
        )}

        {loading ? (
          ""
        ) : (
          <>
            {/* Pagination */}
            {classes && classes.length > 0 && (
              <div className="paginationContainer">
                <Pagination
                  count={pageCount}
                  page={page + 1}
                  onChange={handleChangePage}
                  size="large"
                  color="primary"
                  className="paginationCount"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Classes;
